module.exports = __webpack_public_path__ + "img/75646.b4b9564f.svg";